
import http from '../utils/request.js'
const orderList = (data) => {
    return http.post('/order', data)
}
const getCoupon = ( data ) => {
    return http.post('/coupon', data )
}
const getCommission = () =>{
    return http.post('/commission', {})
}
const getRecord = (param) =>{
    return http.post('/settlement', { action: 'getHistorySettlement', param})
}
const getSettlementDetail = (param) => {
    return http.post('/settlement', { action: 'getSettlementDetail', param })
}
const subscribe = (param) => {
    return http.post('/subscribe', { action: 'subscribe', param })
}
export {
    orderList,
    getCoupon,
    getCommission,
    getRecord,
    getSettlementDetail,
    subscribe
}